<template>
  
  <div>

    <div class="ui large breadcrumb">
      <a v-if="isUpdating" class="section" @click="$historyBack()">
        <i class="reply icon m-r-5"></i> Voltar
      </a>
      <router-link v-else to="/quotations" class="section">
        <i class="reply icon m-r-5"></i> Orçamentos
      </router-link>
      <i class="right chevron icon divider"></i>
      <div v-if="isCreating" class="section">Novo Orçamento</div>
      <div v-else class="section"><i class="info circle icon"></i> {{ quotationId }}</div>
      <span v-if="isUpdating && quotation.statusData" class="animated fadeIn">        
        <i class="right chevron icon divider"></i>
        <div class="section">
          <i class="icon" :class="quotation.statusData.icon + ' ' + quotation.statusData.color"></i> 
          {{ quotation.statusData.description }}
        </div>
        <i class="right chevron icon divider"></i>
        <div class="section">Alterar</div>
      </span>
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-else class="ui grid animated fadeIn">

      <info ref="info" :quotation="quotation" :isCreating="isCreating" 
        :isUpdating="isUpdating" :productInputVisible="productInputVisible" @onChange="onChangeInfo" />

      <customer ref="customer" :quotation="quotation" :isCreating="isCreating" 
        :isUpdating="isUpdating" :productInputVisible="productInputVisible" @onChange="onChangeCustomer" />

      <delivery ref="delivery" :quotation="quotation" :isCreating="isCreating" 
        :isUpdating="isUpdating" :productInputVisible="productInputVisible" @onChange="onChangeDelivery" />

      <payment ref="payment" :quotation="quotation" :isCreating="isCreating" 
        :isUpdating="isUpdating" :productInputVisible="productInputVisible" @onChange="onChangePayment" />

      <products ref="products" :quotation="quotation" :isCreating="isCreating" 
        :isUpdating="isUpdating" @onProductInput="onProductInput" @onChange="onChangeProducts" />

      <competitors ref="competitors" :quotation="quotation" :isCreating="isCreating" 
        :isUpdating="isUpdating" @onChange="onChangeCompetitors" />

      <!--<comments ref="comments" :quotation="quotation" :isCreating="isCreating" 
        :isUpdating="isUpdating" @onChange="onChangeComments" />  -->

      <other-info ref="otherInfo" :quotation="quotation" :isCreating="isCreating" 
        :isUpdating="isUpdating" @onChange="onChangeOtherInfo" />  

      <totals :quotation="quotation" />

      <div class="sixteen wide column">
        <button class="ui basic button" @click="onCancel()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button class="ui blue right floated button" :class="{ 'disabled loading': saving }" @click="onConfirm()">
          <i class="check icon"></i> Confirmar
        </button>
      </div>

    </div>  

  </div>

</template>

<script>

  import Info from "./info.vue"
  import Customer from "./customer.vue"
  import Delivery from "./delivery.vue"
  import Payment from "./payment.vue"
  import Products from "./products.vue"
  import Competitors from "./competitors.vue"
  import Comments from "./comments.vue"
  import OtherInfo from "./other-info.vue"
  import Totals from "./totals.vue"
  import QuotationService from "@/services/quotation-service"
  import { AppBrowser, Message, Scroll, Loader } from "@/utils"

  export default {
    
    data() {
      return {
        quotationId: "",
        requestLeaveConfirmation: true,
        isCreating: false,
        isUpdating: false,
        loading: true,
        saving: false,
        productInputVisible: false,
        itemsChanged: false,
        quotation: { items: [] },
      }
    },

    components: {
      Info,
      Customer,
      Delivery,
      Payment,
      Products,
      Competitors,
      Comments,
      OtherInfo,
      Totals,
    },

    created() {

      AppBrowser.setBeforeUnloadValidation()
      this.quotationId = this.$route.params.id

      if (this.quotationId === "new") {
        
        this.isCreating = true
        this.loading = false
        this.quotation.idUser = this.$store.state.user.id
        QuotationService.updateTotals(this.quotation)

      } else {
        
        this.isUpdating = true
        this.loadQuotation()
      }
    },

    beforeRouteLeave(to, from, next) {
      
      if (!this.requestLeaveConfirmation)
        return next(true)
     
      const leave = window.confirm("Deseja realmente sair ?")
      next(leave)
    },

    beforeDestroy() {
      AppBrowser.removeBeforeUnloadValidation()
    },

    methods: {      

      async loadQuotation() {

        this.loading = true

        try {
          this.quotation = await QuotationService.getById(this.quotationId)
          if (!this.quotation.allowUpdate) {
            if (this.quotation.isOwner || this.quotation.isApprover) {
              this.$router.push(`/quotations/show/${this.quotationId}`)
            } else {
              this.$router.push("/not-found")
            }
          }
          this.loading = false
        } catch (error) {
          this.$errorHandler(error)
        }
      },

      onChangeInfo(data) {

        this.quotation.type = data.type
        this.quotation.validDate = data.validDate        

        this.forceQuotationUpdate()

        this.$refs.payment.loadConditions()        
      },

      onChangeCustomer(data) {
        this.quotation.customer     = data.customer
        this.quotation.codeCustomer = data.customer.code
        this.quotation.unitCustomer = data.customer.unit
        this.quotation.nameCustomer = data.customer.name
        this.quotation.isRetail     = data.isRetail   
        this.quotation.CnpjPadrao   = data.customer.cnpj     

        this.forceQuotationUpdate()
        if (!data.isUpd){
          this.$refs.delivery.clearAddress()
        }
        this.$refs.payment.loadConditions()

        if (data.customer.issueReport)
          this.$refs.otherInfo.setIssueReport((data.customer.issueReport == "S"))
      },

      onChangeDelivery(data) {

        const freightChanged = (this.quotation.freight !== data.freight)

        this.quotation.delZipCode = data.delZipCode
        this.quotation.delAddress = data.delAddress
        this.quotation.delNumber = data.delNumber
        this.quotation.delComplement = data.delComplement
        this.quotation.delCity = data.delCity
        this.quotation.delState = data.delState
        this.quotation.freight = data.freight
        this.quotation.deliveryType = data.deliveryType
        this.quotation.billingDate = data.billingDate

        this.forceQuotationUpdate()

        if (freightChanged) {
          this.itemsChanged = true
          // Lentidao (477272): so recalcula na hora se o toggle estiver ligado; senao, ao salvar.
          if (this.$refs.products.autoRecalc)
            this.$refs.products.updateAllPrices()
        }
      },

      onChangePayment(condition) {

        const paymentChanged = (this.quotation.paymentCondition !== condition.id)

        this.quotation.paymentCondition = condition.id
        this.quotation.descPayment = condition.description

        if (condition.id && QuotationService.isPartialBillingBlocked(condition.id) && this.quotation.isPartialBilling !== false) {
          this.quotation.isPartialBilling = undefined
          this.$refs.otherInfo.resetPartialBilling()
        }

        this.forceQuotationUpdate()

        if (paymentChanged) {
          this.itemsChanged = true
          // Lentidao (477272): so recalcula na hora se o toggle estiver ligado; senao, ao salvar.
          if (this.$refs.products.autoRecalc)
            this.$refs.products.updateAllPrices()
        }
      },

      onChangeProducts() {

        this.itemsChanged = true

        QuotationService.updateTotals(this.quotation)
        
        this.forceQuotationUpdate()
      },

      onProductInput(visible) {
        this.productInputVisible = visible
      },

      onChangeCompetitors(competitors) {
        this.quotation.competitors = competitors
      },

      onChangeComments(comments) {
        this.quotation.comments = comments
      },

      onChangeOtherInfo(data) {

        this.quotation.isIssueReport = data.isIssueReport
        this.quotation.isPallets = data.isPallets
        this.quotation.isPartialBilling = data.isPartialBilling
        this.quotation.customerSalesOrder = data.customerSalesOrder
        this.quotation.shippingMessage = data.shippingMessage
        this.quotation.invoiceMessage = data.invoiceMessage
      },

      forceQuotationUpdate() {
        this.quotation = this.$cloneObject(this.quotation)
      },

      onCancel() {

        if (this.isUpdating) {
          this.$historyBack()
        } else {
          this.$router.push("/quotations")
        }
      },

      async onConfirm() {
        // Bug 22418 (triplo-submit): trava de reentrancia. 'saving' e setado de forma
        // sincrona antes do primeiro await; um novo clique enquanto salva cai aqui e retorna.
        if (this.saving)
          return

        if (!this.validData())
          return
        
        Loader.show()
        this.saving = true     
        
        let id = this.quotationId

        try {

          // Lentidao (477272): garante valores corretos ao salvar — recalcula TODOS os itens uma vez,
          // independentemente do toggle de recalculo automatico (que pode estar desligado).
          // updateAllPrices gerencia o proprio loader; reabrimos o loader em seguida para persistir.
          if (this.$refs.products)
            await this.$refs.products.updateAllPrices()

          Loader.show()

          if (this.isCreating) {

            id = await QuotationService.create(this.quotation)            

          } else {

            await QuotationService.update({
              quotation: this.quotation,
              itemsChanged: this.itemsChanged,
            })

          }

          this.requestLeaveConfirmation = false

          this.$router.push(`/quotations/show/${id}`)
          
        } catch (error) {
          this.$errorHandler(error)
        }

        Loader.hide()
        this.saving = false        
      },

      validData() {

        let isOk = true
        let message = ""
        let elementId = ""
        const quotation = this.quotation
       if (!quotation.type) {
          elementId = "#quotation-info"
          message = "Informe o tipo do orçamento"

        } else if (!quotation.codeCustomer) {
          
          elementId = "#quotation-customer"
          message = "Informe o cliente"

        } else if (typeof quotation.isRetail !== "boolean") {

          elementId = "#quotation-customer"
          message = "Defina se é uma venda para varejo"

        } else if (!quotation.delZipCode || !quotation.delCity || !quotation.delState) { 
          
          elementId = "#quotation-delivery"
          message = "Informe o CEP, município e o estado de entrega"

        } else if (!quotation.freight) {

          elementId = "#quotation-delivery"
          message = "Informe o tipo do frete"
        
        } else if (!quotation.deliveryType) {

          elementId = "#quotation-delivery"
          message = "Informe o tipo de entrega"
        
        } else if (quotation.deliveryType == "2" && !quotation.billingDate) {

          elementId = "#quotation-delivery"
          message = "Informe a data de faturamento"

        } else if (!quotation.paymentCondition) {

          elementId = "#quotation-payment"
          message = "Informe a condição de pagamento"

        } else if (quotation.items.length == 0) {

          elementId = "#quotation-products"
          message = "Nenhum produto adicionado"

        } else if (!quotation.competitors || quotation.competitors.length == 0) {

          elementId = "#quotation-competitors"
          message = "Informe se o orçamento possui concorrência"  

        } else if (typeof quotation.isIssueReport !== "boolean") {

          elementId = "#quotation-other-info"
          message = "Informe se emite laudo"

        } else if (typeof quotation.isPallets !== "boolean") {

          elementId = "#quotation-other-info"
          message = "Informe se aceita pallets"  

        } else if (typeof quotation.isPartialBilling !== "boolean") {

          elementId = "#quotation-other-info"
          message = QuotationService.isPartialBillingBlocked(quotation.paymentCondition)
            ? "Condição de Pagamento não aceita Faturamento Parcial. Informe se aceita faturamento parcial."
            : "Informe se aceita faturamento parcial"

        } else if (quotation.isPartialBilling && QuotationService.isPartialBillingBlocked(quotation.paymentCondition)) {

          elementId = "#quotation-other-info"
          message = "Condição de Pagamento não aceita Faturamento Parcial."
        } else if (quotation.customer.code === "000000" && quotation.customer.unit === "00" && quotation.customer.cnpj.trim() === "" ) {     
            elementId = "#quotation-other-info"
            message = "Orçamento padrão, obrigatório informar CNPJ" 
        }

        if (message) {
          isOk = false
          Scroll.toElement(elementId)
          Message.info(message)
        }

        return isOk
      },
    },
  }

</script>

